import './index.scss';
import { Controller } from 'utils/stimulus';

export default class TrialOffersController extends Controller {
  static targets = ['name', 'price', 'features'];

  connect() {
    this.selected = null;
    this.offer = null;

    this.on('setInitialOffer', this.setInitialOffer.bind(this));
  }

  setInitialOffer(offer) {
    this.offer = offer;

    const { offerName, offerPrice, offerFeatures, offerSubscription } =
      this.offer;

    this.element.setAttribute(
      'class',
      `q-trial-offers q-trial-offers--${offerSubscription}`
    );
    this.nameTarget.textContent = offerName;
    this.priceTarget.textContent = offerPrice;
    this.featuresTarget.innerHTML = offerFeatures
      .split(/true|false/)
      .filter(feature => !!feature)
      .map(
        feature =>
          `<li><i class="q-icon q-icon-check"></i><p>${feature}</p></li>`
      )
      .join('');
  }

  continue() {
    this.trigger('trial-modal->selectOffer', this.offer);
  }
}
